"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var notices_1 = require("./notices/notices");
var nav_menus_1 = require("./nav-menus/nav-menus");
jQuery(document).ready(function () {
    var notices = new notices_1.EpsilonNotices();
    notices.init();
    if (typeof wpNavMenu !== 'undefined') {
        new nav_menus_1.EpsilonNavMenus(wpNavMenu);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/admin/admin.ts
// module id = 37
// module chunks = 2